import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { DadosCursoResponseInterface } from '../../interfaces/curso/dados-curso-response.interface';
import { CursoSubmitUpdateInterface } from '../../interfaces/curso/curso-submit-update.interface';

@Injectable({
  providedIn: 'root'
})
export class DadosCursoService {

  _http = inject(HttpClient)

  getDadosCurso(sigla: string, ofer: string): Observable<DadosCursoResponseInterface> {

    return this._http.get<DadosCursoResponseInterface>(environment.url + '/api/dadosficha/' + sigla + '/' + ofer);
  }

  get_data_inscricao(id: string): Observable<CursoSubmitUpdateInterface> {

    return this._http.get<CursoSubmitUpdateInterface>(environment.url + `/api/dadosPremat/${id}`);
  }

}
